class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-json',
        section: 'cart-json',
        selector: '#cart-json'
      },
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

if (!customElements.get('order-protection')) {
  console.log('order protection')
  customElements.define('order-protection', class OrderProtection extends HTMLElement {
    constructor() {
      super();
      const btn = this.querySelector('a')
      console.log(document.querySelector('#cart-json'))
      const cartJson = JSON.parse(document.querySelector('#cart-json').innerHTML)

      let hasProduct

      for (const item of cartJson.items) {
        if (item.product_id === Number(this.getAttribute('data-id'))) {
          hasProduct = true
        }
      }

      btn.addEventListener('click', () => {
        btn.classList.toggle('active')
        document.querySelector('[data-checkout]').classList.add('free-gift-loading')
        if (this.querySelector('a').classList.contains('active')) {
          CartJS.addItem(btn.getAttribute('data-id'))
        } else {
          CartJS.removeItemById(btn.getAttribute('data-id'))
          localStorage.setItem('manual-cancel-order-production', 'true')
        }
      })

      if (hasProduct) {
        btn.classList.add('active')
      } else {
        btn.classList.remove('active')
      }
    }
  })
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.cartJson = JSON.parse(document.querySelector('#cart-json').innerHTML)

      let currentCount = Number(this.querySelector('span:first-child').innerHTML)

      const protectionId = Number(this.getAttribute('data-order-protection-id'))

      for (const item of this.cartJson.items) {
        if (item.product_id === protectionId) {
          currentCount--
        }
      }

      this.updateCount(currentCount)
    }

    cartJson = null

    updateCount(count) {
      if (count === 0) {
        this.classList.add('hidden')
        return
      }

      this.querySelector('span:first-child').innerHTML = count
      this.classList.remove('hidden')
    }
  })
}
